import React, { useEffect } from 'react';
import {
  FiCheckCircle,
  FiInfo,
  FiGlobe,
  FiShield,
  FiExternalLink,
  FiAlertTriangle,
  FiXOctagon,
  FiRefreshCw,
  FiBook,
  FiMail
} from 'react-icons/fi';
import halfRound from '../assets/images/half_round.png';

const termsItems = [
  {
    icon: FiCheckCircle,
    title: 'Acceptance of Terms',
    text: (
      <>
        By accessing and using the DI Labs website, you accept and agree to be bound by these Terms of Use. If you do not agree, please do not use our website.
      </>
    )
  },
  {
    icon: FiInfo,
    title: 'Description of Service',
    text: (
      <>
        DI Labs is a portfolio website that displays information about mobile applications we have developed and published on the Google Play Store and Apple App Store. The website is for informational purposes only.
      </>
    )
  },
  {
    icon: FiGlobe,
    title: 'Use of Website',
    text: (
      <>
        You may use this website for lawful purposes only. You agree not to:
        <ul style={{ margin: '8px 0 0', paddingLeft: '20px', listStyleType: 'disc' }}>
          <li>Use the website in any way that violates applicable laws or regulations</li>
          <li>Attempt to interfere with the proper functioning of the website</li>
          <li>Copy, reproduce, or distribute content without permission</li>
          <li>Use automated systems to access the website without authorization</li>
        </ul>
      </>
    )
  },
  {
    icon: FiShield,
    title: 'Intellectual Property',
    text: (
      <>
        All content on the DI Labs website, including text, images, logos, and design elements, is the property of DI Labs and is protected by copyright laws. You may view and browse the content for personal, non-commercial use only.
      </>
    )
  },
  {
    icon: FiExternalLink,
    title: 'External Links',
    text: (
      <>
        Our website contains links to third-party websites (Google Play Store and Apple App Store). We are not responsible for the content, privacy practices, or terms of service of these external sites.
      </>
    )
  },
  {
    icon: FiAlertTriangle,
    title: 'Disclaimer of Warranties',
    text: (
      <>
        The DI Labs website is provided "as is" without any warranties, express or implied. We do not guarantee that the website will be error-free, uninterrupted, or free from viruses or other harmful components.
      </>
    )
  },
  {
    icon: FiXOctagon,
    title: 'Limitation of Liability',
    text: (
      <>
        DI Labs shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the website.
      </>
    )
  },
  {
    icon: FiRefreshCw,
    title: 'Modifications to Terms',
    text: (
      <>
        We reserve the right to modify these Terms of Use at any time. Changes will be effective immediately upon posting to the website.
      </>
    )
  },
  {
    icon: FiBook,
    title: 'Governing Law',
    text: (
      <>
        These Terms of Use shall be governed by and construed in accordance with the laws of India.
      </>
    )
  },
  {
    icon: FiMail,
    title: 'Contact Information',
    text: (
      <>
        For questions about these Terms of Use, please contact us at:
        <br />
        <strong>Email:</strong>{' '}
        <a href="mailto:support@dilabs.com" className="privacy-email">support@dilabs.com</a>
      </>
    )
  }
];

const TermsAndCondition = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <main className="privacy-page">
      <div className="home-hero-round-bg">
        <img src={halfRound} alt="" className="home-hero-round-img" />
      </div>

      <div className="privacy-container">
        <header className="privacy-heading-wrap">
          <span className="privacy-badge">Fairness & Transparency</span>
          <h1 className="privacy-main-heading">Terms & Conditions</h1>
        </header>

        <article className="privacy-content">
          <div className="privacy-content-header">
            <h2 className="privacy-section-title">Terms of Use for DI Labs</h2>
            <p className="privacy-date"><strong>Last Updated:</strong> November 7, 2025</p>
          </div>
          <p className="privacy-introduction">
            Please read these terms carefully before using our website or applications. They explain the rules and guidelines that govern your use of DI Labs' services.
          </p>

          <div className="privacy-list">
            {termsItems.map(({ icon: Icon, title, text }, index) => (
              <section className="privacy-policy-item" key={title}>
                <div className="privacy-icon" aria-hidden="true">
                  <Icon />
                </div>
                <div className="privacy-item-copy">
                  <h3 className="privacy-subtitle">{index + 1}. {title}</h3>
                  <div className="privacy-text">{text}</div>
                </div>
              </section>
            ))}
          </div>
        </article>
      </div>
    </main>
  );
};

export default TermsAndCondition;
